





















import _ from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

/**
 * TODO: Integrate with DropdownSelect component
 */
@Component
export default class CountControl extends Vue {
  @Prop({ required: true })
  max: number

  @Prop({ default: 0 })
  min: number

  @Prop({ required: true })
  count: number

  get range(): number[] {
    return _.range(this.min, this.max + 1)
  }

  get options(): Array<{key: number, value: number, selected: boolean}> {
    return this.range.map(n => ({
      key: n,
      value: n,
      selected: n === this.count,
    }))
  }

  handleChange(event: Event) {
    this.emitSelected(parseInt((event.target! as HTMLInputElement).value, 10))
  }

  @Emit('input')
  emitSelected(_selected: number) {
    // Do nothing
  }
}
